import CommonUtil from "../utils/CommonUtil";

const validateLength = value => value && value.length >= 1;

const validateDateFromTo = value => value && value.dateFrom && value.dateTo;

const validateDateFrom = value => value && value.dateFrom;

const createValidationRule = (
  isText = false,
  isDateFromTo = false,
  isDateFrom = false
) => {
  var rule = { required: true };

  if (isText) {
    rule.validate = validateLength;
  }
  if (isDateFromTo) {
    rule.validate = validateDateFromTo;
  }
  if (isDateFrom) {
    rule.validate = validateDateFrom;
  }

  return rule;
};

const createTextValidationRules = fields =>
  fields.reduce(
    (acc, key) => ({
      ...acc,
      [key]: createValidationRule(true)
    }),
    {}
  );

const createObjectValidationRules = fields =>
  fields.reduce(
    (acc, key) => ({
      ...acc,
      [key]: createValidationRule()
    }),
    {}
  );

const createDateFromValidationRules = fields =>
  fields.reduce(
    (acc, key) => ({
      ...acc,
      [key]: createValidationRule(false, false, true)
    }),
    {}
  );

export const validateEntity = (entity, validationRule) => {
  return Object.keys(validationRule).every(key => {
    const field = CommonUtil.getDeep(entity, key);
    const { required, validate } = validationRule[key];

    if (required && !field) return false;
    if (validate && !validate(field)) return false;

    return true;
  });
};

const nameValidationRule = {
  ...createTextValidationRules(["name"])
};

const dateFromValidationRule = {
  ...createDateFromValidationRules(["dateFromTo"])
};

export const rolesValidationRules = {
  roleTypeDetails: {
    ...nameValidationRule,
    ...dateFromValidationRule,
    ...createObjectValidationRules(["partyRoleTypeDiscriminator"])
  }
};

export const usersValidationRules = {
  userRoles: {
    ...dateFromValidationRule,
    ...createObjectValidationRules(["partyRoleType"])
  },
  involvementRoles: {
    ...dateFromValidationRule,
    ...createObjectValidationRules(["involvementRoleType"])
  }
};

export const knowledgeValidationRules = {
  generalData: {
    ...nameValidationRule,
    ...dateFromValidationRule
  }
};

export const classificationValidationRules = {
  generalData: {
    ...nameValidationRule,
    ...dateFromValidationRule
  },
  classificationDetail: {
    ...nameValidationRule,
    ...dateFromValidationRule,
    ...createObjectValidationRules([
      "classificationStatus",
      "classificationType"
    ])
  }
};

export const knowledgeItemValidationRules = {
  knowledgeItem: {
    ...nameValidationRule,
    ...dateFromValidationRule,
    ...createObjectValidationRules(["knowledgeType", "knowledgeCopyright"])
  },
  document: {
    ...nameValidationRule
  }
};

export const lifeCycleValidationRules = {
  lifeCycle: {
    ...nameValidationRule,
    ...dateFromValidationRule,
    ...createObjectValidationRules(["lifeCycleStateType.id"])
  },
  lifeCycleStateType: {
    ...nameValidationRule,
    ...dateFromValidationRule
  },
  lifeCycleClassDefinition: {
    ...nameValidationRule
  }
};

export const messageLogTypeValidationRules = {
  generalData: {
    ...nameValidationRule,
    ...dateFromValidationRule
  }
};

export const involvementRoleTypeValidationRules = {
  generalData: {
    ...nameValidationRule,
    ...dateFromValidationRule
  }
};

export const involvementRoleValidationRules = {
  involvementRole: {
    ...dateFromValidationRule,
    ...createObjectValidationRules(["involvementRoleType"])
  }
};
